import UpdatePassword from "components/UpdatePassword/UpdatePassword";
import LoginSecurity from "components/LoginSecurity/LoginSecurity";

const Security = () => {
    return (
        <div>
            <UpdatePassword />
            <LoginSecurity />
        </div>
    );
};

export default Security;
